import type {
  ContextState,
  DateFilterSelectedValues,
  DateRangeFilterSelectedValues,
  Filter,
  GetterClass,
  RegularFilterSelectedValues,
} from '../../../models'

import { FilterTypeEnum } from '../../../enums'

import { CONTEXT_CONSTS } from '../../../store/context/context.consts'

export class AppliedFiltersCountGetter implements GetterClass {
  static execute(this: void, state: ContextState, getters: any): number {
    const enabledFilters: Record<string, Filter> = getters[CONTEXT_CONSTS.getters.enabledFilters]
    return Object.values(enabledFilters).reduce((appliedFiltersCount: number, filter: Filter) => {
      if (!filter.config.mandatory) {
        const hasSelectedValues = {
          [FilterTypeEnum.DATE]: () =>
            (filter.selectedValues as DateFilterSelectedValues).some(
              (value: number) => value !== undefined,
            ),
          [FilterTypeEnum.DATE_RANGE]: () =>
            (filter.selectedValues as DateRangeFilterSelectedValues).some(
              (value: string) => value !== undefined && value !== '',
            ),
          [FilterTypeEnum.REALTIME]: () => filter.selectedValues !== undefined,
          [FilterTypeEnum.REGULAR]: () =>
            !!(filter.selectedValues as RegularFilterSelectedValues).length,
        }[filter.config.type]()
        if (hasSelectedValues) {
          appliedFiltersCount++
        }
      }
      return appliedFiltersCount
    }, 0)
  }
}
